import { set_node_reward } from "@/api";
import { drawNodeReward } from "@/contract";

/**
 * 提取节点奖励：先调后端 set_node_reward 同步链上数据，再调用 drawNodeReward
 * @param {string} walletAddress
 */
export async function withdrawNodeReward(walletAddress) {
  const wallet = String(walletAddress || "").trim();
  if (!wallet) {
    return Promise.reject(new Error("请先连接钱包"));
  }
  await set_node_reward({ wallet });
  return drawNodeReward();
}
